import api from './api-wrapper';
import axios from 'axios';
import config from '@/services/config';

const V3_SEARCHER = '/api/v3/searcher';
const V1_FINDER = '/api/v1/finder';
const V3_PROFILE = '/api/v3/profile';
const V3_LISTS = '/api/v3/lists';

const unwrapResponse = (response) => response?.response ?? response;

/**
 * Helper for PHP/Laravel external services that use brandme-key
 */
const externalRequest = (baseUrl, method, endpoint, data = null) => {
  const url = `${baseUrl}${endpoint}`;
  const headers = { 'brandme-key': process.env.VUE_APP_BRANDME_KEY };
  const requestConfig = { method, url, headers };
  if (data) requestConfig.data = data;
  return axios(requestConfig).then((res) => res.data?.data ?? res.data);
};

const phpPost = (endpoint, data) => externalRequest(config.urlPhp, 'POST', endpoint, data);
const laravelPost = (endpoint, data) => externalRequest(config.urlLaravel, 'POST', endpoint, data);

// Search (PHP - public, brandme-key)
export const getResults = (data) => phpPost('/api/v1/buscador/influencers', data);
export const freeSearcher = (data) => phpPost('/api/v2/buscador/gratis', data);
export const freeLookalikeSearcher = (data) => phpPost('/api/v2/lookalike', data);
export const getMainInfluencers = (country) => phpPost('/api/v2/main/influencers', { country });

// Summary Influencer (PHP/Laravel - public, brandme-key)
export const getSummaryInfluencer = (network, username) => {
  const endpoint = (network === 'tiktok' || network === 'youtube') ? '/api/v2/vpn-summary-influencer/' : '/api/v2/summary-influencer/';
  const baseUrl = (network === 'tiktok' || network === 'youtube') ? config.urlLaravel : config.urlPhp;
  return externalRequest(baseUrl, 'POST', endpoint, { network, username });
};
export const getSummaryInfluencerTiktok = (network, username) => laravelPost('/api/v2/vpn-summary-influencer/', { network, username });

// History Subscribers (PHP/Laravel - public, brandme-key)
export const getHistorySuscribers = (data) => {
  const url = `${config.urlPhp}/api/v2/history/${data.network}/${data.username}`;
  const headers = { 'brandme-key': process.env.VUE_APP_BRANDME_KEY };
  return axios.get(url, { headers }).then((res) => res.data?.data ?? res.data);
};
export const getHistorySuscribersLaravel = (data) => laravelPost('/api/v2/vpn-history', data);
export const getHistorySuscribersTiktok = (network, username) => laravelPost('/api/v2/vpn-history/', { network, username });

// Search History (Core - authenticated)
export const getHistorySearches = (data, page = 1, size_page = 10) => api.post(`${V3_SEARCHER}/history/`, data, { params: { page, size_page } }).then(unwrapResponse);
export const toggleFavoriteSearch = (searcher_uuid) => api.get(`${V3_SEARCHER}/toggle-favorite/${searcher_uuid}/`).then(unwrapResponse);
export const deleteHistorySearch = (searcher_uuid) => api.get(`${V3_SEARCHER}/history-delete/${searcher_uuid}/`);
export const toggleFavoriteHistorySearch = (searcher_uuid) => api.get(`${V3_SEARCHER}/toggle-favorite/${searcher_uuid}/`);
export const changeTitleHistory = (searcher_uuid, data) => api.post(`${V3_SEARCHER}/change-title/${searcher_uuid}/`, data).then(unwrapResponse);
export const getMainLocations = () => api.get(`${V3_SEARCHER}/main-locations/`).then(unwrapResponse);

// Finder (Core - authenticated)
export const saveLogSearch = (data) => api.post(`${V1_FINDER}/log/search/`, data);
export const getFirstPage = (data) => api.post(`${V1_FINDER}/searcher/`, data).then(unwrapResponse);
export const analize = (name, net = '') => api.post(`${V1_FINDER}/suggester/`, { query: name, networks: net }).then(unwrapResponse);
export const getCategories = (network) => api.get(`${V1_FINDER}/get/taxonomy/${network}/`).then(unwrapResponse);
export const getInfluencerIn = (username, network, objecttype) => api.get(`${V1_FINDER}/searcher/influencer-in/${username}/${network}/${objecttype}/`).then(unwrapResponse);

// Location (External base - no auth)
export const getLocation = (loc) => {
  return axios.get(`${config.urlBase}/search-location`, { params: { query: loc } }).then((res) => res.data?.data ?? res.data);
};

// Profile & Lists (Core - authenticated)
export const unlockReport = (data) => api.post(`${V3_PROFILE}/report/unlock/`, data).then(unwrapResponse);
export const addFavoritesInfluencer = (data) => api.post(`${V3_LISTS}/add-favorites/`, data).then(unwrapResponse);
